<ng-container class="reason">
    <ngx-select class="reason" [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
        [disabled]="ngxDisabled" [(ngModel)]="reasonSelected" placeholder="Seleccionar Causa" (select)="changeReason($event)"
        appendTo="body" dropDownMenuOtherClasses="reason">

        <ng-template ngx-select-option-not-found let-input>
            "{{input}}" no encontrada
        </ng-template>
    </ngx-select>
</ng-container>